import React from "react";
import ToggleButton from "react-toggle-button";

const TogglingButton = ({ value = false, setState }) => {
  return (
    <ToggleButton
      inactiveLabel={""}
      activeLabel={""}
      colors={{
        activeThumb: {
          base: "rgb(255,255,255)",
        },
        inactiveThumb: {
          base: "rgb(255,255,255)",
        },
        active: {
          base: "rgb(232, 119, 34)",
        },
        inactive: {
          base: "rgb(0,0,0)",
        },
      }}
      value={value}
      onToggle={(value) => {
        value ? setState(false) : setState(true);
      }}
    />
  );
};

export default TogglingButton;
